import { IClusterInfo, IConstellationInfo } from "../../../model/CarbonExternalModels";

export const getNumberOfNodes = (cluster: IClusterInfo) => {
    let totalNumberOfDevices = 0;

    for (let i = 0; i < cluster.clusterDeviceInfo.length; i++) {
        const clusterDeviceInfo = cluster.clusterDeviceInfo[i];
        if (clusterDeviceInfo.active) {
            totalNumberOfDevices++;
        }
    }

    return totalNumberOfDevices;
};

export const getTotalNumberOfUClients = (
    foundObject: { cluster: IClusterInfo; constellation: IConstellationInfo },
    totalNumberOfDevices: number,
) => {
    let totalUClients = 0;

    if (
        foundObject?.cluster?.clusterDeviceInfo === undefined ||
        foundObject?.cluster?.clusterDeviceInfo.length !== totalNumberOfDevices
    ) {
        return -1;
    }

    for (let i = 0; i < totalNumberOfDevices; i++) {
        const clusterDeviceInfo = foundObject.cluster.clusterDeviceInfo[i];

        if (!clusterDeviceInfo || !clusterDeviceInfo.active) {
            continue;
        }

        totalUClients += clusterDeviceInfo.endpoint.offline + clusterDeviceInfo.endpoint.online;
    }

    return totalUClients;
};
